export default __webpack_public_path__ + "static/media/looksrare.ec79b9fe.webp";